'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SettingsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.5 12C18.5 11 19.1 10.1 19.9 9.70001C19.5 8.40001 18.8 7.20001 17.9 6.30001C17.5 6.60001 17 6.70001 16.5 6.70001C15.1 6.70001 13.9 5.50001 13.9 4.10001C13.9 4.00001 13.9 4.00001 13.9 3.90001C13.3 3.80001 12.6 3.70001 12 3.70001C11.4 3.70001 10.7 3.80001 10.1 4.00001C10.1 4.10001 10.1 4.20001 10.1 4.20001C10.1 5.60001 8.99998 6.80001 7.49998 6.80001C6.89998 6.80001 6.39998 6.60001 5.99998 6.30001C5.09998 7.30001 4.49998 8.40001 4.09998 9.70001C4.89998 10.1 5.49998 11 5.49998 12C5.49998 13 4.89998 13.9 4.09998 14.3C4.49998 15.6 5.19998 16.8 6.09998 17.7C6.49998 17.4 6.99998 17.3 7.49998 17.3C8.89998 17.3 10.1 18.5 10.1 19.9C10.1 20 10.1 20 10.1 20.1C10.7 20.2 11.4 20.3 12 20.3C12.6 20.3 13.3 20.2 13.9 20.1C13.9 20 13.9 20 13.9 19.9C13.9 18.5 15 17.3 16.5 17.3C17 17.3 17.5 17.5 17.9 17.7C18.8 16.8 19.5 15.6 19.9 14.3C19.1 13.9 18.5 13 18.5 12ZM12 14.5C10.6 14.5 9.49998 13.4 9.49998 12C9.49998 10.6 10.6 9.60001 12 9.60001C13.4 9.60001 14.5 10.7 14.5 12C14.5 13.3 13.4 14.5 12 14.5Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpSettingsIcon = forwardRef(SettingsIcon);

export { VpSettingsIcon as default };
